import http from "@/utils/request"

export default {
	secret: {
		query: async function (data = {}) {
			return await http.get("secret/query", data);
		},
		save: async function (data = {}) {
			return await http.post("secret/save", data);
		},
		valid: async function (data = {}) {
			return await http.post("secret/valid", data);
		},
	},
	record: {
		list: async function (data = {}) {
			return await http.get("developer/record/list", data);
		},
	},
	notify: {
		list: async function (data = {}) {
			return await http.get("developer/notify/list", data);
		},
	}
}
